module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/ko_hokkaido-c25c506ebe52b273ee511159c954aab9.jpg";